import React, { useEffect } from 'react'
import { useCreateNotificationInAppStore, useUpdateNotificationInApp } from '@workspace/frontend-kit'
import { constants } from '../../../utilities/constants'
import { Banner } from '../../common/banner/Banner'

export const NotificationAlert: React.FC = () => {
    const { notifications, dispatch } = useCreateNotificationInAppStore()
    const { updateNotificationInApp } = useUpdateNotificationInApp()

    useEffect(() => {
        dispatch({
            type: 'DISABLE_BADGE_NOTIFICATION',
            source: constants.NOTIFICATIONS_SOURCE.UPDATE_ANN,
        })
        updateNotificationInApp(constants.NOTIFICATIONS_SOURCE.UPDATE_ANN)

        return () => {
            dispatch({
                type: 'DELETE_NOTIFICATION',
                source: constants.NOTIFICATIONS_SOURCE.UPDATE_ANN,
            })
        }
    }, [])
    const notificationData = notifications[constants.NOTIFICATIONS_SOURCE.UPDATE_ANN]?.data
    const enableAlert = notificationData?.length > 0 || false

    if (!enableAlert) {
        return null
    }
    return <Banner text={notificationData[notificationData.length - 1]?.content || ''} />
}
